/* Sisters Lemonade — wire the custom inquiry forms to HubSpot.
 * Any <form data-hs-portal="..." data-hs-form="..."> on the page is handled:
 * validates first name + email, POSTs {firstname, email, message} to HubSpot's
 * public Forms Submission API, then swaps the form for an inline thank-you.
 * Fields expected by name: firstname, email, notes (notes maps to HubSpot "message").
 * On success it sends GA4 generate_lead (gtag comes from assets/sl-lead-tracking.js).
 */
(function () {
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function val(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? String(el.value || '').trim() : '';
  }

  function cookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : '';
  }

  function ensureError(form) {
    var err = form.querySelector('.hs-form-error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'hs-form-error';
      err.setAttribute('role', 'alert');
      err.hidden = true;
      err.style.cssText = 'grid-column:1/-1;color:#e2483d;font-size:14px;font-weight:600;margin:10px 0 0';
      form.appendChild(err);
    }
    return err;
  }

  function showThanks(form) {
    var parent = form.parentNode;
    // Hide the form's siblings in the card (heading + subhead) so only the thanks shows.
    Array.prototype.forEach.call(parent.children, function (c) {
      if (c !== form) { c.style.display = 'none'; }
    });
    var box = document.createElement('div');
    box.className = 'hs-form-thanks';
    box.setAttribute('role', 'status');
    box.style.cssText = 'padding:8px 0';
    box.innerHTML =
      '<h2 style="margin:0 0 10px;font-size:clamp(24px,3vw,34px);font-weight:800;line-height:1.12">Thanks — we’ll be in touch!</h2>' +
      '<p style="margin:0;font-size:16px;opacity:.85">Your request just landed in our inbox. We’ll reach out shortly.</p>';
    parent.replaceChild(box, form);
  }

  function wire(form) {
    if (form.dataset.hsWired) { return; }
    var portal = form.getAttribute('data-hs-portal');
    var guid = form.getAttribute('data-hs-form');
    if (!portal || !guid) { return; }
    form.dataset.hsWired = '1';
    var endpoint = 'https://api.hsforms.com/submissions/v3/integration/submit/' + portal + '/' + guid;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = ensureError(form);
      err.hidden = true;

      var firstname = val(form, 'firstname');
      var email = val(form, 'email');
      var notes = val(form, 'notes');

      if (!firstname) { err.textContent = 'Please enter your first name.'; err.hidden = false; return; }
      if (!EMAIL_RE.test(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; return; }

      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

      var ctx = { pageUri: location.href, pageName: document.title };
      var hutk = cookie('hubspotutk');
      if (hutk) { ctx.hutk = hutk; }

      var payload = {
        fields: [
          { name: 'firstname', value: firstname },
          { name: 'email', value: email },
          { name: 'message', value: notes }
        ],
        context: ctx
      };

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.json(); })
        .then(function () {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'generate_lead', { lead_type: 'inquiry', form_id: guid, page_path: location.pathname });
          }
          showThanks(form);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          err.textContent = 'Sorry, something went wrong. Please try again in a moment.';
          err.hidden = false;
        });
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[data-hs-form]');
    for (var i = 0; i < forms.length; i++) { wire(forms[i]); }
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
